import { render, staticRenderFns } from "./headNav.vue?vue&type=template&id=81235e6a&scoped=true&"
import script from "./headNav.vue?vue&type=script&lang=js&"
export * from "./headNav.vue?vue&type=script&lang=js&"
import style0 from "./headNav.vue?vue&type=style&index=0&id=81235e6a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81235e6a",
  null
  
)

export default component.exports